// removed by extract-text-webpack-plugin
module.exports = {"Menu":"Menu__Menu___2-lTo","MenuChessfilter":"Menu__MenuChessfilter___3wIuO","scrollArea":"Menu__scrollArea___4REyF","Wrapper":"Menu__Wrapper___18uPO","Arrow":"Menu__Arrow___1kmSu","RightArrow":"Menu__RightArrow___2AF3c","RightArrowInCollection":"Menu__RightArrowInCollection___3jRsQ","AdditionalFilters":"Menu__AdditionalFilters___z8U51","FiltersMenu":"Menu__FiltersMenu___2omZS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Menu/Menu.scss
// module id = 1468
// module chunks = 0